import { LabDataModel, AppointmentDataModel, UserProfileModel, NewsAndPromotions} from "../../Model/index";

export class DashboardDataContainer {

    labReports: LabDataModel[] = [];
    appointments: AppointmentDataModel[] = [];
    RecentAppointments: AppointmentDataModel[] = [];
    userprofile: UserProfileModel = new UserProfileModel();
    lstUserProfile: UserProfileModel[] = [];
    newsAndPromotions: NewsAndPromotions[] = [];
    ValidUser: boolean;
    IsSearchPatientValid: boolean;
    SessionTimeout: string;
    BookingType: string;
    PaylaterStatus: string;	
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/dashboard/dashboarddatacontainer.ts